import { CommonModule } from '@angular/common';
import {
  Component,
  forwardRef,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user/user.service';
import * as alertifyjs from 'alertifyjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import Swal from'sweetalert2';

import {
  mobiscroll,
  MbscDatetimeOptions,
  MbscFormOptions,
} from '@mobiscroll/angular';
@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.css'],
})
export class PaymentMethodComponent implements OnInit {
  @Input() code_person: any;
  @Output() changeView = new EventEmitter<any>();
  @Output() editView = new EventEmitter<any>();
  @ViewChild('miInput') miInput: ElementRef | undefined;
  @Output() resetStatus = new EventEmitter<any>();
  @Input() estatus_approve: any;
  /** Modo solo-lectura: oculta el formulario de registro y los botones de acción
   *  (editar, eliminar, activar afiliación). Útil para embeber el listado en otras vistas. */
  @Input() readOnly: boolean = false;
  

  @ViewChild('miInput') miInputVariable: ElementRef | undefined;
  mobileSettingsFile: MbscDatetimeOptions = {
    display: 'bottom',
  };

  form: any;
  submit_disabled: any;

  country: any;
  city: any;
  state: any;
  type: any;

  errorMsg: any;
  loadForm: any;
  loadPerson_Address: any;
  section_transactions: any = [];
  accounts: any = [];
  section_complete: any;
  validation_account_number: any;
  banks: any = [];
  bank: any;

  formDataUpload: any = null;
  fileName = '';
  value = '';
  last_value = this.value;

  sessionUser: any;
  direct_debit_customer: any;

  // 🆕 FASE 6: Propiedades multi-producto
  selectedProduct: string = 'CREDIT';
  products: any[] = [
    { code: 'CREDIT', name: 'Crédito' },
    { code: 'SEGUROS_MERCANTIL', name: 'Seguros Mercantil' },
    { code: 'RECARGAS', name: 'Recargas' }
  ];
  groupedAccounts: any = {};
  showGrouped: boolean = false;
  statistics: any = {};
  
  // 🆕 Propiedades para copiar cuenta a otro producto
  selectedAccountToCopy: any = null;
  targetProductType: string = '';
  isLoadingCopy: boolean = false;

  constructor(
    private _common: CommonService,
    private formBuilder: FormBuilder,
    private _user: UserService,
    public _auth: AuthService
  ) {}

  async ngOnInit() {
    this.sessionUser = this._auth.sessionUser;
    this.form = this.formBuilder.group({
      bank: ['', [Validators.required]],
      currency: ['63ffb65dbb023a686c40ab8c', [Validators.required]],
      payment_method: ['640b83e26522a425711e006f', [Validators.required]],
      account_type: ['', [Validators.required]],
      account_number: ['', [Validators.required, Validators.minLength(20)]],
      product_type: ['CREDIT', [Validators.required]], // 🆕 FASE 6: Campo producto
    });

    console.log('🚀 [ngOnInit] Inicializando payment-method component');
    console.log('👤 [ngOnInit] code_person:', this.code_person);

    this.getDirectDebitActive();
    this.getBanks();
    
    // 🆕 FASE 6: Cargar vista agrupada por defecto
    this.showGrouped = true;
    console.log('📋 [ngOnInit] showGrouped:', this.showGrouped);
    await this.getAccountsGrouped();
  }

  getDirectDebitActive = async (product_type: string = 'CREDIT') => {
    let person = await this._user.getPersonbyCode({
      code: this.code_person,
    });

    person = person.resp;
    // 🆕 Pasar product_type para filtrar procesos activos por producto
    this.direct_debit_customer = await this._user.customerDirectDebitProcesses(
      person.identitys[0].code_identity.name,
      person.identitys[0].identity,
      product_type
    );
    this.direct_debit_customer = this.direct_debit_customer.res;
    console.log(`🔍 [getDirectDebitActive] Procesos activos de ${product_type}:`, this.direct_debit_customer.length);
  }

  ngAfterViewInit() {
    if(this.miInput) {
      this.miInput.nativeElement.onpaste = function(e: any) {
        e.preventDefault();
      };
      this.miInput.nativeElement.oncopy = function(e: any) {
        e.preventDefault();
      };
    }
  }

  onChange = ($event: any) => {
    let target = $event.target as HTMLInputElement;
    let value = target.value;

    if (value) {
      if (value && value.length >= 4) {
        this.value = value;
        this.last_value = this.value;
      } else {
        this.value = this.last_value;
      }
    } else {
      this.value = this.last_value;
    }

    this.form.patchValue({
      account_number: this.value,
    });
  };

  reset() {
    this.formDataUpload = null;
    this.fileName = '';
  }

  onFileSelected = async (event: any) => {
    const file: File = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.formDataUpload = file;
    }
  };

  setBank = async () => {
    try {
      const data = this.form.getRawValue();

      let banks_resp = this.banks?.filter((item: any) => {
        return item.code == data.bank;
      });

      this.bank = banks_resp[0];
      this.value = this.bank.bankCode;
      this.last_value = this.value;
      this.form.patchValue({
        account_number: this.bank.bankCode,
      });
    } catch (error) {
      console.error(error);
    }
  };

  getBanks = async () => {
    try {
      const resp = await this.getBanksServer();
      // La fuente ya devuelve solo bancos domiciliables (direct_debit_active).
      // Mantenemos el guard de que tengan bankCode.
      this.banks = (resp?.res || []).filter((item: any) => !!item.bankCode);
      this.setBank();
    } catch (error) {
      console.error(error);
    }
  };

  getBanksServer = async () => {
    try {
      // Por ahora solo se permiten registrar bancos domiciliables (direct_debit_active).
      // Usa el endpoint de consola de débito directo en vez del listado general.
      return this._user.getBanksWithDirectDebitEnabled({});
    } catch (error) {
      console.error(error);
    }
  };

  getLists = async () => {
    try {
      this.loadForm = true;
      const [country, city, state, type] = await Promise.all([
        await this._common.getCountry({}),
        await this._common.getCity({}),
        await this._common.getState({}),
        await this._common.getTypeAddress({}),
      ]);

      this.country = country.resp;
      this.city = city.resp;
      this.state = state.resp;
      this.type = type.resp;
      this.loadForm = false;
    } catch (error) {
      console.log(error);
    }
  };

  getAccounts = async () => {
    try {
      this.loadPerson_Address = true;
      
      // 🆕 FASE 6: Si está en modo agrupado, usar endpoint agrupado
      if (this.showGrouped) {
        await this.getAccountsGrouped();
        return;
      }
      
      let resp = await this._common.getPayment_method({
        code_person: this.code_person,
      });

      this.accounts = resp?.resp;
      this.loadPerson_Address = false;
    } catch (error) {
      console.log(error);
      this.loadPerson_Address = false;
    }
  };

  edit_account = async (payment_method_customer: any) => {
    this.editView.emit({
      view: 6,
      id: payment_method_customer,
    });
  };

  delete_account = async (payment_method_customer: any) => {

    Swal.fire({
      title: "¿Desea eliminar la cuenta?",
      text: "¡No podrás revertir esto!",
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      inputAttributes: {
        autocapitalize: "off"
      },
      showCancelButton: true,
      confirmButtonText: `Si!`,
      allowOutsideClick: () => !Swal.isLoading(),
      customClass: {
        container: 'swal-custom-container'
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        let params = {
          payment_method_customer: payment_method_customer,
        };
    
        try {
          let resp = await this._common.delete_payment_method(params);
    
          this.getAccounts();
    
          this.submit_disabled = false;
        } catch (error: any) {
          debugger;
          const params = error?.error;
          if (params?.code) {
            this.errorMsg = params?.msg;
            alertifyjs.error(params?.msg);

          }
          this.submit_disabled = false;
        }
      }
    });


    
  };

  submit = async () => {
    const data = this.form.getRawValue();
    console.log(data.account_number);
    console.log(this.bank.bankCode);
    if (this.form.valid) {
      if(data.account_number.toString().substring(0,  4) === this.bank.bankCode){
        this.submit_disabled = true;
        

        // 🆕 MULTI-PRODUCTO: Incluir product_type al guardar
        let params = {
          person_code: this.code_person,
          code_bank: data.bank,
          currency: data.currency,
          payment_method: data.payment_method,
          account_type: data.account_type,
          account_number: data.account_number,
          product_type: data.product_type || 'CREDIT', // 🆕 MULTI-PRODUCTO
          //user: this.sessionUser.uid
        };

        const formData = new FormData();

        if (this.formDataUpload) {
          formData.append('archivo', this.formDataUpload);
        }

        formData.append('params', JSON.stringify(params));

        try {
          let resp = await this._common.setPayment_method(formData);
          // let resp = await this._common.setPayment_method(params);
          alertifyjs.success('Registro exitoso');

          // 🆕 MULTI-PRODUCTO: Mantener product_type al resetear
          this.form = this.formBuilder.group({
            product_type: [data.product_type || 'CREDIT', [Validators.required]], // 🆕 Mantener producto seleccionado
            bank: ['', [Validators.required]],
            currency: ['63ffb65dbb023a686c40ab8c', [Validators.required]],
            payment_method: ['640b83e26522a425711e006f', [Validators.required]],
            account_type: ['01', [Validators.required]],
            account_number: ['', [Validators.required]],
          });

          this.reset();

          this.getAccounts();

          this.setBank();

          this.resetStatus.emit(true);

          this.submit_disabled = false;
        } catch (error: any) {
          const params = error?.error;
          if (params) {
            this.errorMsg = params?.msg;
          }
          alertifyjs.error(this.errorMsg);
          this.submit_disabled = false;
        }
      } else {
        
        this.form.patchValue({
          account_number: this.bank.bankCode,
        });
        this.submit_disabled = false;
        alertifyjs.error('Los primeros 4 dígitos del número de cuenta no son válidos para una cuenta del banco seleccionado.');
      }
    }
  };

  setChange(View: any) {
    this.changeView.emit(View);
  }

  validate_account_number = () => {
    let campo = this.form.controls.account_number.value;

    if (campo.length == 20) {
      this.validation_account_number = true;
    } else {
      this.validation_account_number = false;
    }
  };

  changeDomiciliation = (payment_method_customer: any) => {
    if(this.direct_debit_customer.length===0) {
      if(!payment_method_customer.direct_debit_default && payment_method_customer.afiliation.status==="COMPLETE") {
        Swal.fire({
          title: "¿Desea activar la domiciliación "+ payment_method_customer?.bank?.name+"?",
          text: "",
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: `Si`,
          allowOutsideClick: () => !Swal.isLoading(),
          customClass: {
            container: 'swal-custom-container'
          }
        }).then(async (result) => {
          if (result.isConfirmed) {
            // 🆕 FASE 4: Agregar product_type
            await this._common.change_domiciliation({
              payment_method_customer: payment_method_customer._id,
              afiliation: payment_method_customer.afiliation,
              product_type: payment_method_customer.product_type || 'CREDIT'
            });
            this.getAccounts();
            this.resetStatus.emit(true);
          }
        });
      } 
    } else {
      Swal.fire({
        text: "El cliente posee un cobro activo de Domiciliación, por seguridad no se pueden realizar acciones sobre la afiliación mientrás se encuentre activo.",
        title: "Importante!",
        icon: "warning"
      });
    }
  }

  unlinkDomiciliation = (payment_method_customer: any) => {
    if(this.direct_debit_customer.length===0) {
      if(payment_method_customer.direct_debit_default) {
        Swal.fire({
          title: "¿Desea desactivar la domiciliación "+ payment_method_customer?.bank?.name+"?",
          text: "",
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: `Si`,
          allowOutsideClick: () => !Swal.isLoading(),
          customClass: {
            container: 'swal-custom-container'
          }
        }).then(async (result) => {
          if (result.isConfirmed) {
            // 🆕 FASE 4: Agregar product_type
            await this._common.change_domiciliation({
              payment_method_customer: payment_method_customer._id,
              product_type: payment_method_customer.product_type || 'CREDIT'
            });
            this.getAccounts();
            this.resetStatus.emit(true);
          }
        });
      } 
    } else {
      Swal.fire({
        text: "El cliente posee un cobro activo de Domiciliación, por seguridad no se pueden realizar acciones sobre la afiliación mientrás se encuentre activo.",
        title: "Importante!",
        icon: "warning"
      });
    }
  }


  
  activateAfiliation = (payment_method_customer: any) => {
    if(this.direct_debit_customer.length===0) {
      if(!payment_method_customer.afiliation ) {
        Swal.fire({
          title: "¿Desea activar la cuenta de para el proceso de Domiciliación?",
          text: "",
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: `Si`,
          allowOutsideClick: () => !Swal.isLoading(),
          customClass: {
            container: 'swal-custom-container'
          }
        }).then(async (result) => {
          if (result.isConfirmed) {
            await this._common.create_domiciliation({
              payment_method_customer: payment_method_customer._id
            });
            this.getAccounts();
          }
        });
      } 
    } else {
      Swal.fire({
        text: "El cliente posee un cobro activo de Domiciliación, por seguridad no se pueden realizar acciones sobre la afiliación mientrás se encuentre activo.",
        title: "Importante!",
        icon: "warning"
      });
    }
  }

  createAfiliation = (payment_method_customer: any) => {
    if(this.direct_debit_customer.length===0) {
      if(!payment_method_customer.afiliation ) {
        Swal.fire({
          title: "¿Desea afiliar la cuenta de "+payment_method_customer?.customer?.name+" a "+ payment_method_customer?.bank?.name+"?",
          text: "",
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: `Si`,
          allowOutsideClick: () => !Swal.isLoading(),
          customClass: {
            container: 'swal-custom-container'
          }
        }).then(async (result) => {
          if (result.isConfirmed) {
            await this._common.reset_afiliation_domiciliation({
              payment_method_customer: payment_method_customer._id
            });
            this.getAccounts();
          }
        });
      } 
    } else {
      Swal.fire({
        text: "El cliente posee un cobro activo de Domiciliación, por seguridad no se pueden realizar acciones sobre la afiliación mientrás se encuentre activo.",
        title: "Importante!",
        icon: "warning"
      });
    }
  }

  deleteAfiliation = (payment_method_customer: any, afiliation: any) => {
    if(this.direct_debit_customer.length===0) {
      if(payment_method_customer.afiliation ) {
        Swal.fire({
          title: "¿Desea desafiliar la cuenta de "+ payment_method_customer?.bank?.name+" a la Domiciliación?",
          text: "",
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: `Si`,
          allowOutsideClick: () => !Swal.isLoading(),
          customClass: {
            container: 'swal-custom-container'
          }
        }).then(async (result) => {
          if (result.isConfirmed) {
            await this._common.delete_afiliation_domiciliation({
              payment_method_customer: payment_method_customer._id,
              afiliation: afiliation._id,
              user: this.sessionUser.uid
            });
            this.getAccounts();
          }
        });
      } 
    } else {
      Swal.fire({
        text: "El cliente posee un cobro activo de Domiciliación, por seguridad no se pueden realizar acciones sobre la afiliación mientrás se encuentre activo.",
        title: "Importante!",
        icon: "warning"
      });
    }
  }

  // ═══════════════════════════════════════════════════════════════
  // 🆕 FASE 6: MÉTODOS MULTI-PRODUCTO
  // ═══════════════════════════════════════════════════════════════

  /**
   * Cambiar el producto seleccionado en el formulario
   */
  onProductChange = async (product: string) => {
    this.selectedProduct = product;
    this.form.patchValue({
      product_type: product
    });
    // 🆕 Recargar procesos activos del producto seleccionado
    await this.getDirectDebitActive(product);
  }

  /**
   * Alternar vista agrupada/lista
   */
  toggleGroupedView = async () => {
    this.showGrouped = !this.showGrouped;
    
    if (this.showGrouped) {
      await this.getAccountsGrouped();
    } else {
      await this.getAccounts();
    }
  }

  /**
   * Obtener payment methods agrupados por producto
   */
  getAccountsGrouped = async () => {
    try {
      this.loadPerson_Address = true;
      console.log('🔍 [getAccountsGrouped] Consultando payment methods agrupados para:', this.code_person);
      
      const resp = await this._user.getPaymentMethodsGrouped({
        code_person: this.code_person,
      });

      console.log('📦 [getAccountsGrouped] Respuesta del backend:', resp);

      if (resp?.success) {
        this.groupedAccounts = resp.payment_methods_by_product || {};
        this.statistics = resp.statistics || {};
        console.log('✅ [getAccountsGrouped] Cuentas agrupadas:', this.groupedAccounts);
        console.log('📊 [getAccountsGrouped] Estadísticas:', this.statistics);
        console.log('🔑 [getAccountsGrouped] Productos encontrados:', Object.keys(this.groupedAccounts));
      } else {
        console.warn('⚠️ [getAccountsGrouped] Respuesta no exitosa:', resp);
      }
      
      this.loadPerson_Address = false;
    } catch (error) {
      console.error('❌ [getAccountsGrouped] Error:', error);
      this.loadPerson_Address = false;
    }
  }

  /**
   * Obtener nombre del producto
   */
  getProductName = (productCode: string): string => {
    const product = this.products.find(p => p.code === productCode);
    return product ? product.name : productCode;
  }

  /**
   * Obtener keys del objeto agrupado
   */
  getProductKeys = (): string[] => {
    const keys = Object.keys(this.groupedAccounts);
    console.log('🔑 [getProductKeys] Keys disponibles:', keys);
    return keys;
  }

  /**
   * 🆕 Abrir modal para copiar cuenta a otro producto
   */
  openCopyToProductModal = (account: any) => {
    this.selectedAccountToCopy = account;
    this.targetProductType = '';
    this.isLoadingCopy = false;
    
    // Mostrar modal usando DOM API
    const modalElement = document.getElementById('copyToProductModal');
    if (modalElement) {
      modalElement.classList.add('show');
      modalElement.style.display = 'block';
      document.body.classList.add('modal-open');
      
      // Agregar backdrop
      const backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show';
      backdrop.id = 'copyToProductModalBackdrop';
      document.body.appendChild(backdrop);
    }
  }

  /**
   * 🆕 Obtener productos disponibles (excluir el actual)
   */
  getAvailableProducts = (): any[] => {
    if (!this.selectedAccountToCopy) return this.products;
    
    const currentProduct = this.selectedAccountToCopy.product_type || 'CREDIT';
    return this.products.filter(p => p.code !== currentProduct);
  }

  /**
   * 🆕 Cerrar modal de copiar cuenta
   */
  closeCopyToProductModal = () => {
    const modalElement = document.getElementById('copyToProductModal');
    if (modalElement) {
      modalElement.classList.remove('show');
      modalElement.style.display = 'none';
      document.body.classList.remove('modal-open');
      
      // Remover backdrop
      const backdrop = document.getElementById('copyToProductModalBackdrop');
      if (backdrop) {
        backdrop.remove();
      }
    }
  }

  /**
   * 🆕 Copiar cuenta a otro producto
   */
  copyToProduct = async () => {
    if (!this.selectedAccountToCopy || !this.targetProductType) {
      alertifyjs.error('Debe seleccionar un producto destino');
      return;
    }

    this.isLoadingCopy = true;

    try {
      const response: any = await this._user.copyPaymentMethodToProduct({
        payment_method_customer_id: this.selectedAccountToCopy._id,
        target_product_type: this.targetProductType
      });

      if (response.success) {
        alertifyjs.success(response.msg || 'Cuenta copiada exitosamente');
        
        // Mostrar información adicional
        if (response.requires_terms_acceptance) {
          setTimeout(() => {
            alertifyjs.warning('El cliente debe aceptar los Términos y Condiciones para este producto');
          }, 1500);
        }

        // Cerrar modal
        this.closeCopyToProductModal();

        // Recargar cuentas
        await this.getAccountsGrouped();
        
        // Resetear
        this.selectedAccountToCopy = null;
        this.targetProductType = '';
      } else {
        alertifyjs.error(response.msg || 'Error al copiar la cuenta');
      }
    } catch (error: any) {
      console.error('Error copiando cuenta:', error);
      alertifyjs.error(error?.error?.msg || 'Error al copiar la cuenta');
    } finally {
      this.isLoadingCopy = false;
    }
  }

}
